import { render, staticRenderFns } from "./ChatNavbar.vue?vue&type=template&id=76fd451a"
import script from "./ChatNavbar.vue?vue&type=script&lang=js"
export * from "./ChatNavbar.vue?vue&type=script&lang=js"
import style0 from "./ChatNavbar.vue?vue&type=style&index=0&id=76fd451a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports